import { render, staticRenderFns } from "./AiGenerativeCandidateView.vue?vue&type=template&id=0a8ee463&scoped=true&"
import script from "./AiGenerativeCandidateView.vue?vue&type=script&lang=ts&"
export * from "./AiGenerativeCandidateView.vue?vue&type=script&lang=ts&"
import style0 from "./AiGenerativeCandidateView.vue?vue&type=style&index=0&id=0a8ee463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ee463",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VProgressCircular,VRow})
